import React, { FunctionComponent, InputHTMLAttributes } from 'react';
import { UseFormMethods } from 'react-hook-form';
import useTranslate from 'Hooks/useTranslate';
import { PASSWORD_PATTERN } from 'SharedHelpers/validatation';
import Input from 'SharedComponents/Input';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
    formApi: UseFormMethods;
}

const PasswordInput: FunctionComponent<Props> = props => {
    const { tPlain } = useTranslate();
    const { formApi, ...rest } = props;

    return (
        <Input
            type="password"
            name="password"
            className="qa-login-signup-form__password"
            showError={!!formApi.errors.password}
            placeholder={tPlain('signupOverlay_Password placeholder')}
            ref={formApi.register({
                required: tPlain('signupOverlay_Invalid password'),
                pattern: { value: PASSWORD_PATTERN, message: tPlain('signupOverlay_Invalid password') },
            })}
            errorMsg={formApi.errors?.password?.message}
            onChange={() => formApi.clearErrors('password')}
            {...rest}
        />
    );
};

export default PasswordInput;
